import baseRequest from './baseRequest';

export async function getTextScreen(id: string) {
  return (await baseRequest.get(`/api/text-screens/${id}`)).data.htmlText;
}
